export default "__VITE_ASSET__aadb41f9__"